import {
  getExperienceId as getExperienceIdFromStorage,
  setExperienceId as setExperienceIdInStorage,
} from "@swa-ui/application";
import { getSearchParam } from "@swa-ui/browser";
import { usePersistedState } from "@swa-ui/persistence";

import { getApiKey } from "../getApiKey";
import { getChannelId } from "../getChannelId";

export const usePersistedApplicationContext = () => {
  const [apiKey] = usePersistedState({
    defaultValue: getApiKey(),
    key: "usePersistedApplicationContext-apiKey",
    persistDefault: true,
  });
  const [appVersion] = usePersistedState({
    defaultValue: getAppVersion(),
    key: "usePersistedApplicationContext-appVersion",
    persistDefault: true,
  });
  const [channelId] = usePersistedState({
    defaultValue: getChannelId(),
    key: "usePersistedApplicationContext-channelId",
    persistDefault: true,
  });
  const [deviceType] = usePersistedState({
    defaultValue: getDeviceType(),
    key: "usePersistedApplicationContext-deviceType",
    persistDefault: true,
  });
  const [diagnostic] = usePersistedState({
    defaultValue: getDiagnostic(),
    key: "usePersistedApplicationContext-diagnostic",
    persistDefault: true,
  });
  const [returnToUrl] = usePersistedState({
    defaultValue: getReturnToUrl(),
    key: "usePersistedApplicationContext-returnToUrl",
    persistDefault: true,
  });

  return {
    apiKey,
    appVersion,
    channelId,
    deviceType,
    diagnostic,
    experienceId: getExperienceId(),
    returnToUrl,
  };

  function getAppVersion() {
    return [getSearchParam("appVersion"), process.env.VERSION].filter(Boolean).join("|");
  }

  function getDeviceType() {
    return getSearchParam("deviceType") ?? "";
  }

  function getDiagnostic() {
    const appVersionParam = getSearchParam("appVersion");

    return JSON.stringify({
      spa: process.env.VERSION,
      ...(appVersionParam && { native: appVersionParam }),
    });
  }

  function getExperienceId() {
    const experienceIdParam = getSearchParam("experienceId");

    experienceIdParam && setExperienceIdInStorage(experienceIdParam);

    return getExperienceIdFromStorage();
  }

  function getReturnToUrl() {
    const returnToUrlParam = getSearchParam("returnToURL");

    return returnToUrlParam ? decodeURIComponent(returnToUrlParam) : "";
  }
};
